<template>

    <div class="background">


        <van-nav-bar
                title="表单开码"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
        />





        <div style="padding:0.5rem 0;">

            <div  class="inputForm" v-html="formIntro"></div>
        </div>


        <p style="font-weight:bold;font-size:2.5rem;">{{formTitle}}推广</p>
        <div style="padding:0.5rem 0;">
            <div class="inputForm">



                    <template v-for="(item,index) of fieldArray">
                        <template v-if="item.compType==='input'">
                            <van-field  show-word-limit v-model="query[item.id]" :name="item.id"  :placeholder="item.placeholder" :label="item.label" required clearable/>
                        </template>
                        <template v-if="item.compType==='province'">
                            <van-field v-model="query.province"  label="省级地址" placeholder="请选择省/市" readonly clearable  @click="showProvince=true"/>


                         </template>
                        <template v-if="item.compType==='city'">
                            <van-field v-model="query.city" label="市级地址" placeholder="请选择市/区" readonly clearable  @click="openCityPopup"/>
                        </template>

                      <template v-else-if="item.compType === 'image'">
                        <van-field :label="item.label" :required="item.required">
                          <template #input>
                            <van-uploader
                                v-model="query[item.id]"
                            :max-count="1"
                            :deletable="true"
                            :before-read="beforeRead"
                            :after-read="afterRead.bind(null, item.id)"
                            :upload-text="item.placeholder"
                            />
                          </template>
                        </van-field>
                      </template>

                    </template>



                <van-button type="danger" size="large" round @click="submit" style="margin-top:2rem;height:3rem;">提交</van-button>
            </div>

            <div class="inputForm" style="margin-top: 15px">
            <div v-for="task in formList" :key="task.id"  style="margin: auto" >
                <van-cell-group>

                    <van-cell>
                        <van-row style="display:block"   >
                            <van-col span="12" v-if='fieldArray[0]'>
                              <div v-if="fieldArray[0]['compType'] == 'image'">

                                <img :src="task[fieldArray[0]['id']]"  style="max-width: 100%; max-height: 200px; object-fit: contain;"/>
                              </div>
                              <div v-else> {{fieldArray[0]["label"]}}：{{task[fieldArray[0]["id"]]}}</div>

                            </van-col>
                            <van-col span="12" v-if='fieldArray[1]'>

                              <div v-if="fieldArray[1]['compType'] == 'image'">

                              <img :src="task[fieldArray[1]['id']]"  style="max-width: 100%; max-height: 200px; object-fit: contain;"/>
                              </div>
                              <div v-else> {{fieldArray[1]["label"]}}：{{task[fieldArray[1]["id"]]}}</div>

                            </van-col>

                            <van-col span="12" ></van-col>
                            <van-col span="12" >
                                <div v-if="task.flag == '0'">开通中</div>
                                <div v-if="task.flag == '1'">开通成功</div>
                                <div v-if="task.flag == '2'">开通失败</div>
                                <div v-if="task.flag == '3'">已提交</div>
                            </van-col>
                        </van-row>

                    </van-cell>
                </van-cell-group>

            </div>

            </div>
        </div>

        <van-popup v-model="showProvince" position="bottom">
            <van-picker show-toolbar title="省/市选择" :columns="provinceList" @confirm="onProvinceConfirm" @cancel="showProvince=false"/>



        </van-popup>

        <van-popup v-model="showCity" position="bottom">
            <van-picker show-toolbar title="市/区选择" :columns="cityList" @confirm="onCityConfirm" @cancel="showCity=false"/>
        </van-popup>
    </div>
</template>

<script>
    import taobaotejiaAPI from '@/api/taobaotejia';
    import mainAPI from '@/api/main'
    import axios from 'axios';


    export default {
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    traderId:this.$route.query.traderId,
                },
                provinceMap: [],
                provinceList: [],
                cityList: [],
                showProvince: false,
                showCity: false,

                fieldArray:[],
                queryReg:{},
                formTitle:"",
                formIntro:"",
                formList:[],
                formProvince:[{"name":"北京","id":"1"},{"name":"上海","id":"2"},{"name":"天津","id":"3"},{"name":"重庆","id":"4"},{"name":"河北","id":"5"},{"name":"山西","id":"6"},{"name":"河南","id":"7"},{"name":"辽宁","id":"8"},{"name":"吉林","id":"9"},{"name":"黑龙江","id":"10"},{"name":"内蒙古","id":"11"},{"name":"江苏","id":"12"},{"name":"山东","id":"13"},{"name":"安徽","id":"14"},{"name":"浙江","id":"15"},{"name":"福建","id":"16"},{"name":"湖北","id":"17"},{"name":"湖南","id":"18"},{"name":"广东","id":"19"},{"name":"广西","id":"20"},{"name":"江西","id":"21"},{"name":"四川","id":"22"},{"name":"海南","id":"23"},{"name":"贵州","id":"24"},{"name":"云南","id":"25"},{"name":"西藏","id":"26"},{"name":"陕西","id":"27"},{"name":"甘肃","id":"28"},{"name":"青海","id":"29"},{"name":"宁夏","id":"30"},{"name":"新疆","id":"31"},{"name":"台湾","id":"32"},{"name":"钓鱼岛","id":"84"},{"name":"港澳","id":"52993"}],
                formCityMap:{
                    "1":[{"province_id":"1","name":"朝阳区","id":"72"},{"province_id":"1","name":"海淀区","id":"2800"},{"province_id":"1","name":"西城区","id":"2801"},{"province_id":"1","name":"东城区","id":"2802"},{"province_id":"1","name":"崇文区","id":"2803"},{"province_id":"1","name":"宣武区","id":"2804"},{"province_id":"1","name":"丰台区","id":"2805"},{"province_id":"1","name":"石景山区","id":"2806"},{"province_id":"1","name":"门头沟","id":"2807"},{"province_id":"1","name":"房山区","id":"2808"},{"province_id":"1","name":"通州区","id":"2809"},{"province_id":"1","name":"大兴区","id":"2810"},{"province_id":"1","name":"顺义区","id":"2812"},{"province_id":"1","name":"怀柔区","id":"2814"},{"province_id":"1","name":"密云区","id":"2816"},{"province_id":"1","name":"昌平区","id":"2901"},{"province_id":"1","name":"平谷区","id":"2953"},{"province_id":"1","name":"延庆区","id":"3065"}],
                    "2":[{"province_id":"2","name":"黄浦区","id":"78"},{"province_id":"2","name":"徐汇区","id":"2813"},{"province_id":"2","name":"长宁区","id":"2815"},{"province_id":"2","name":"静安区","id":"2817"},{"province_id":"2","name":"闸北区","id":"2820"},{"province_id":"2","name":"虹口区","id":"2822"},{"province_id":"2","name":"杨浦区","id":"2823"},{"province_id":"2","name":"宝山区","id":"2824"},{"province_id":"2","name":"闵行区","id":"2825"},{"province_id":"2","name":"嘉定区","id":"2826"},{"province_id":"2","name":"浦东新区","id":"2830"},{"province_id":"2","name":"青浦区","id":"2833"},{"province_id":"2","name":"松江区","id":"2834"},{"province_id":"2","name":"金山区","id":"2835"},{"province_id":"2","name":"奉贤区","id":"2837"},{"province_id":"2","name":"普陀区","id":"2841"},{"province_id":"2","name":"崇明区","id":"2919"}],
                    "3":[{"province_id":"3","name":"东丽区","id":"51035"},{"province_id":"3","name":"和平区","id":"51036"},{"province_id":"3","name":"河北区","id":"51037"},{"province_id":"3","name":"河东区","id":"51038"},{"province_id":"3","name":"河西区","id":"51039"},{"province_id":"3","name":"红桥区","id":"51040"},{"province_id":"3","name":"蓟州区","id":"51041"},{"province_id":"3","name":"静海区","id":"51042"},{"province_id":"3","name":"南开区","id":"51043"},{"province_id":"3","name":"滨海新区","id":"51044"},{"province_id":"3","name":"西青区","id":"51045"},{"province_id":"3","name":"武清区","id":"51046"},{"province_id":"3","name":"津南区","id":"51047"},{"province_id":"3","name":"汉沽区","id":"51048"},{"province_id":"3","name":"大港区","id":"51049"},{"province_id":"3","name":"北辰区","id":"51050"},{"province_id":"3","name":"宝坻区","id":"51051"},{"province_id":"3","name":"宁河区","id":"51052"}],
                    "4":[{"province_id":"4","name":"万州区","id":"113"},{"province_id":"4","name":"涪陵区","id":"114"},{"province_id":"4","name":"梁平区","id":"115"},{"province_id":"4","name":"南川区","id":"119"},{"province_id":"4","name":"潼南区","id":"123"},{"province_id":"4","name":"大足区","id":"126"},{"province_id":"4","name":"黔江区","id":"128"},{"province_id":"4","name":"武隆区","id":"129"},{"province_id":"4","name":"丰都县","id":"130"},{"province_id":"4","name":"奉节县","id":"131"},{"province_id":"4","name":"开州区","id":"132"},{"province_id":"4","name":"云阳县","id":"133"},{"province_id":"4","name":"忠县","id":"134"},{"province_id":"4","name":"巫溪县","id":"135"},{"province_id":"4","name":"巫山县","id":"136"},{"province_id":"4","name":"石柱县","id":"137"},{"province_id":"4","name":"彭水县","id":"138"},{"province_id":"4","name":"垫江县","id":"139"},{"province_id":"4","name":"酉阳县","id":"140"},{"province_id":"4","name":"秀山县","id":"141"},{"province_id":"4","name":"城口县","id":"4164"},{"province_id":"4","name":"璧山区","id":"48131"},{"province_id":"4","name":"荣昌区","id":"48132"},{"province_id":"4","name":"铜梁区","id":"48133"},{"province_id":"4","name":"合川区","id":"48201"},{"province_id":"4","name":"巴南区","id":"48202"},{"province_id":"4","name":"北碚区","id":"48203"},{"province_id":"4","name":"江津区","id":"48204"},{"province_id":"4","name":"渝北区","id":"48205"},{"province_id":"4","name":"长寿区","id":"48206"},{"province_id":"4","name":"永川区","id":"48207"},{"province_id":"4","name":"江北区","id":"50950"},{"province_id":"4","name":"南岸区","id":"50951"},{"province_id":"4","name":"九龙坡区","id":"50952"},{"province_id":"4","name":"沙坪坝区","id":"50953"},{"province_id":"4","name":"大渡口区","id":"50954"},{"province_id":"4","name":"綦江区","id":"50995"},{"province_id":"4","name":"渝中区","id":"51026"},{"province_id":"4","name":"高新区","id":"51027"},{"province_id":"4","name":"北部新区","id":"51028"}],
                    "5":[{"province_id":"5","name":"石家庄市","id":"142"},{"province_id":"5","name":"邯郸市","id":"148"},{"province_id":"5","name":"邢台市","id":"164"},{"province_id":"5","name":"保定市","id":"199"},{"province_id":"5","name":"张家口市","id":"224"},{"province_id":"5","name":"承德市","id":"239"},{"province_id":"5","name":"秦皇岛市","id":"248"},{"province_id":"5","name":"唐山市","id":"258"},{"province_id":"5","name":"沧州市","id":"264"},{"province_id":"5","name":"廊坊市","id":"274"},{"province_id":"5","name":"衡水市","id":"275"}],
                    "6":[{"province_id":"6","name":"太原市","id":"303"},{"province_id":"6","name":"大同市","id":"309"},{"province_id":"6","name":"阳泉市","id":"318"},{"province_id":"6","name":"晋城市","id":"325"},{"province_id":"6","name":"朔州市","id":"330"},{"province_id":"6","name":"晋中市","id":"336"},{"province_id":"6","name":"忻州市","id":"350"},{"province_id":"6","name":"吕梁市","id":"368"},{"province_id":"6","name":"临汾市","id":"379"},{"province_id":"6","name":"运城市","id":"398"},{"province_id":"6","name":"长治市","id":"3074"}],
                    "7":[{"province_id":"7","name":"郑州市","id":"412"},{"province_id":"7","name":"开封市","id":"420"},{"province_id":"7","name":"洛阳市","id":"427"},{"province_id":"7","name":"平顶山市","id":"438"},{"province_id":"7","name":"焦作市","id":"446"},{"province_id":"7","name":"鹤壁市","id":"454"},{"province_id":"7","name":"新乡市","id":"458"},{"province_id":"7","name":"安阳市","id":"468"},{"province_id":"7","name":"濮阳市","id":"475"},{"province_id":"7","name":"许昌市","id":"482"},{"province_id":"7","name":"漯河市","id":"489"},{"province_id":"7","name":"三门峡市","id":"495"},{"province_id":"7","name":"南阳市","id":"502"},{"province_id":"7","name":"商丘市","id":"517"},{"province_id":"7","name":"周口市","id":"527"},{"province_id":"7","name":"驻马店市","id":"538"},{"province_id":"7","name":"信阳市","id":"549"},{"province_id":"7","name":"济源市","id":"2780"}],
                    "8":[{"province_id":"8","name":"沈阳市","id":"560"},{"province_id":"8","name":"大连市","id":"573"},{"province_id":"8","name":"鞍山市","id":"579"},{"province_id":"8","name":"抚顺市","id":"584"},{"province_id":"8","name":"本溪市","id":"589"},{"province_id":"8","name":"丹东市","id":"593"},{"province_id":"8","name":"锦州市","id":"598"},{"province_id":"8","name":"葫芦岛市","id":"604"},{"province_id":"8","name":"营口市","id":"609"},{"province_id":"8","name":"盘锦市","id":"613"},{"province_id":"8","name":"阜新市","id":"617"},{"province_id":"8","name":"辽阳市","id":"621"},{"province_id":"8","name":"朝阳市","id":"632"},{"province_id":"8","name":"铁岭市","id":"6858"}],
                    "9":[{"province_id":"9","name":"长春市","id":"639"},{"province_id":"9","name":"吉林市","id":"644"},{"province_id":"9","name":"四平市","id":"651"},{"province_id":"9","name":"通化市","id":"657"},{"province_id":"9","name":"白山市","id":"664"},{"province_id":"9","name":"松原市","id":"674"},{"province_id":"9","name":"白城市","id":"681"},{"province_id":"9","name":"延边朝鲜族自治州","id":"687"},{"province_id":"9","name":"辽源市","id":"2992"}],
                    "10":[{"province_id":"10","name":"哈尔滨市","id":"698"},{"province_id":"10","name":"齐齐哈尔市","id":"712"},{"province_id":"10","name":"鹤岗市","id":"727"},{"province_id":"10","name":"双鸭山市","id":"731"},{"province_id":"10","name":"鸡西市","id":"737"},{"province_id":"10","name":"大庆市","id":"742"},{"province_id":"10","name":"伊春市","id":"753"},{"province_id":"10","name":"牡丹江市","id":"757"},{"province_id":"10","name":"佳木斯市","id":"765"},{"province_id":"10","name":"七台河市","id":"773"},{"province_id":"10","name":"黑河市","id":"776"},{"province_id":"10","name":"绥化市","id":"782"},{"province_id":"10","name":"大兴安岭地区","id":"793"}],
                    "11":[{"province_id":"11","name":"呼和浩特市","id":"799"},{"province_id":"11","name":"包头市","id":"805"},{"province_id":"11","name":"乌海市","id":"810"},{"province_id":"11","name":"赤峰市","id":"812"},{"province_id":"11","name":"乌兰察布市","id":"823"},{"province_id":"11","name":"锡林郭勒盟","id":"835"},{"province_id":"11","name":"呼伦贝尔市","id":"848"},{"province_id":"11","name":"鄂尔多斯市","id":"870"},{"province_id":"11","name":"巴彦淖尔市","id":"880"},{"province_id":"11","name":"阿拉善盟","id":"891"},{"province_id":"11","name":"兴安盟","id":"895"},{"province_id":"11","name":"通辽市","id":"902"}],
                    "12":[{"province_id":"12","name":"南京市","id":"904"},{"province_id":"12","name":"徐州市","id":"911"},{"province_id":"12","name":"连云港市","id":"919"},{"province_id":"12","name":"淮安市","id":"925"},{"province_id":"12","name":"宿迁市","id":"933"},{"province_id":"12","name":"盐城市","id":"939"},{"province_id":"12","name":"扬州市","id":"951"},{"province_id":"12","name":"泰州市","id":"959"},{"province_id":"12","name":"南通市","id":"965"},{"province_id":"12","name":"镇江市","id":"972"},{"province_id":"12","name":"常州市","id":"978"},{"province_id":"12","name":"无锡市","id":"984"},{"province_id":"12","name":"苏州市","id":"988"}],
                    "13":[{"province_id":"13","name":"济南市","id":"1000"},{"province_id":"13","name":"青岛市","id":"1007"},{"province_id":"13","name":"淄博市","id":"1016"},{"province_id":"13","name":"枣庄市","id":"1022"},{"province_id":"13","name":"东营市","id":"1025"},{"province_id":"13","name":"潍坊市","id":"1032"},{"province_id":"13","name":"烟台市","id":"1042"},{"province_id":"13","name":"威海市","id":"1053"},{"province_id":"13","name":"莱芜市","id":"1058"},{"province_id":"13","name":"德州市","id":"1060"},{"province_id":"13","name":"临沂市","id":"1072"},{"province_id":"13","name":"聊城市","id":"1081"},{"province_id":"13","name":"滨州市","id":"1090"},{"province_id":"13","name":"菏泽市","id":"1099"},{"province_id":"13","name":"日照市","id":"1108"},{"province_id":"13","name":"泰安市","id":"1112"},{"province_id":"13","name":"济宁市","id":"2900"}],
                    "14":[{"province_id":"14","name":"铜陵市","id":"1114"},{"province_id":"14","name":"合肥市","id":"1116"},{"province_id":"14","name":"淮南市","id":"1121"},{"province_id":"14","name":"淮北市","id":"1124"},{"province_id":"14","name":"芜湖市","id":"1127"},{"province_id":"14","name":"蚌埠市","id":"1132"},{"province_id":"14","name":"马鞍山市","id":"1137"},{"province_id":"14","name":"安庆市","id":"1140"},{"province_id":"14","name":"黄山市","id":"1151"},{"province_id":"14","name":"滁州市","id":"1159"},{"province_id":"14","name":"阜阳市","id":"1167"},{"province_id":"14","name":"亳州市","id":"1174"},{"province_id":"14","name":"宿州市","id":"1180"},{"province_id":"14","name":"池州市","id":"1201"},{"province_id":"14","name":"六安市","id":"1206"},{"province_id":"14","name":"宣城市","id":"2971"}],
                    "15":[{"province_id":"15","name":"宁波市","id":"1158"},{"province_id":"15","name":"杭州市","id":"1213"},{"province_id":"15","name":"温州市","id":"1233"},{"province_id":"15","name":"嘉兴市","id":"1243"},{"province_id":"15","name":"湖州市","id":"1250"},{"province_id":"15","name":"绍兴市","id":"1255"},{"province_id":"15","name":"金华市","id":"1262"},{"province_id":"15","name":"衢州市","id":"1273"},{"province_id":"15","name":"丽水市","id":"1280"},{"province_id":"15","name":"台州市","id":"1290"},{"province_id":"15","name":"舟山市","id":"1298"}],
                    "16":[{"province_id":"16","name":"福州市","id":"1303"},{"province_id":"16","name":"厦门市","id":"1315"},{"province_id":"16","name":"三明市","id":"1317"},{"province_id":"16","name":"莆田市","id":"1329"},{"province_id":"16","name":"泉州市","id":"1332"},{"province_id":"16","name":"漳州市","id":"1341"},{"province_id":"16","name":"南平市","id":"1352"},{"province_id":"16","name":"龙岩市","id":"1362"},{"province_id":"16","name":"宁德市","id":"1370"}],
                    "17":[{"province_id":"17","name":"武汉市","id":"1381"},{"province_id":"17","name":"黄石市","id":"1387"},{"province_id":"17","name":"襄阳市","id":"1396"},{"province_id":"17","name":"十堰市","id":"1405"},{"province_id":"17","name":"荆州市","id":"1413"},{"province_id":"17","name":"宜昌市","id":"1421"},{"province_id":"17","name":"孝感市","id":"1432"},{"province_id":"17","name":"黄冈市","id":"1441"},{"province_id":"17","name":"咸宁市","id":"1458"},{"province_id":"17","name":"恩施州","id":"1466"},{"province_id":"17","name":"鄂州市","id":"1475"},{"province_id":"17","name":"荆门市","id":"1477"},{"province_id":"17","name":"随州市","id":"1479"},{"province_id":"17","name":"潜江市","id":"2922"},{"province_id":"17","name":"天门市","id":"2980"},{"province_id":"17","name":"仙桃市","id":"2983"},{"province_id":"17","name":"神农架林区","id":"3154"}],
                    "18":[{"province_id":"18","name":"长沙市","id":"1482"},{"province_id":"18","name":"株洲市","id":"1488"},{"province_id":"18","name":"湘潭市","id":"1495"},{"province_id":"18","name":"衡阳市","id":"1501"},{"province_id":"18","name":"邵阳市","id":"1511"},{"province_id":"18","name":"岳阳市","id":"1522"},{"province_id":"18","name":"常德市","id":"1530"},{"province_id":"18","name":"张家界市","id":"1540"},{"province_id":"18","name":"郴州市","id":"1544"},{"province_id":"18","name":"益阳市","id":"1555"},{"province_id":"18","name":"永州市","id":"1560"},{"province_id":"18","name":"怀化市","id":"1574"},{"province_id":"18","name":"娄底市","id":"1586"},{"province_id":"18","name":"湘西州","id":"1592"}],
                    "19":[{"province_id":"19","name":"广州市","id":"1601"},{"province_id":"19","name":"深圳市","id":"1607"},{"province_id":"19","name":"珠海市","id":"1609"},{"province_id":"19","name":"汕头市","id":"1611"},{"province_id":"19","name":"韶关市","id":"1617"},{"province_id":"19","name":"河源市","id":"1627"},{"province_id":"19","name":"梅州市","id":"1634"},{"province_id":"19","name":"惠州市","id":"1643"},{"province_id":"19","name":"汕尾市","id":"1650"},{"province_id":"19","name":"东莞市","id":"1655"},{"province_id":"19","name":"中山市","id":"1657"},{"province_id":"19","name":"江门市","id":"1659"},{"province_id":"19","name":"佛山市","id":"1666"},{"province_id":"19","name":"阳江市","id":"1672"},{"province_id":"19","name":"湛江市","id":"1677"},{"province_id":"19","name":"茂名市","id":"1684"},{"province_id":"19","name":"肇庆市","id":"1690"},{"province_id":"19","name":"云浮市","id":"1698"},{"province_id":"19","name":"清远市","id":"1704"},{"province_id":"19","name":"潮州市","id":"1705"},{"province_id":"19","name":"揭阳市","id":"1709"}],
                    "20":[{"province_id":"20","name":"南宁市","id":"1715"},{"province_id":"20","name":"柳州市","id":"1720"},{"province_id":"20","name":"桂林市","id":"1726"},{"province_id":"20","name":"梧州市","id":"1740"},{"province_id":"20","name":"北海市","id":"1746"},{"province_id":"20","name":"防城港市","id":"1749"},{"province_id":"20","name":"钦州市","id":"1753"},{"province_id":"20","name":"贵港市","id":"1757"},{"province_id":"20","name":"玉林市","id":"1761"},{"province_id":"20","name":"贺州市","id":"1792"},{"province_id":"20","name":"百色市","id":"1806"},{"province_id":"20","name":"河池市","id":"1818"},{"province_id":"20","name":"来宾市","id":"3044"},{"province_id":"20","name":"崇左市","id":"3168"}],
                    "21":[{"province_id":"21","name":"南昌市","id":"1827"},{"province_id":"21","name":"景德镇市","id":"1832"},{"province_id":"21","name":"萍乡市","id":"1836"},{"province_id":"21","name":"新余市","id":"1842"},{"province_id":"21","name":"九江市","id":"1845"},{"province_id":"21","name":"鹰潭市","id":"1857"},{"province_id":"21","name":"上饶市","id":"1861"},{"province_id":"21","name":"宜春市","id":"1874"},{"province_id":"21","name":"抚州市","id":"1885"},{"province_id":"21","name":"吉安市","id":"1898"},{"province_id":"21","name":"赣州市","id":"1911"}],
                    "22":[{"province_id":"22","name":"成都市","id":"1930"},{"province_id":"22","name":"自贡市","id":"1946"},{"province_id":"22","name":"攀枝花市","id":"1950"},{"province_id":"22","name":"泸州市","id":"1954"},{"province_id":"22","name":"绵阳市","id":"1960"},{"province_id":"22","name":"德阳市","id":"1962"},{"province_id":"22","name":"广元市","id":"1977"},{"province_id":"22","name":"遂宁市","id":"1983"},{"province_id":"22","name":"内江市","id":"1988"},{"province_id":"22","name":"乐山市","id":"1993"},{"province_id":"22","name":"宜宾市","id":"2005"},{"province_id":"22","name":"广安市","id":"2016"},{"province_id":"22","name":"南充市","id":"2022"},{"province_id":"22","name":"达州市","id":"2033"},{"province_id":"22","name":"巴中市","id":"2042"},{"province_id":"22","name":"雅安市","id":"2047"},{"province_id":"22","name":"眉山市","id":"2058"},{"province_id":"22","name":"资阳市","id":"2065"},{"province_id":"22","name":"阿坝州","id":"2070"},{"province_id":"22","name":"甘孜州","id":"2084"},{"province_id":"22","name":"凉山州","id":"2103"}],
                    "23":[{"province_id":"23","name":"海口市","id":"2121"},{"province_id":"23","name":"儋州市","id":"3034"},{"province_id":"23","name":"琼海市","id":"3115"},{"province_id":"23","name":"万宁市","id":"3137"},{"province_id":"23","name":"东方市","id":"3173"},{"province_id":"23","name":"三亚市","id":"3690"},{"province_id":"23","name":"文昌市","id":"3698"},{"province_id":"23","name":"五指山市","id":"3699"},{"province_id":"23","name":"临高县","id":"3701"},{"province_id":"23","name":"澄迈县","id":"3702"},{"province_id":"23","name":"定安县","id":"3703"},{"province_id":"23","name":"屯昌县","id":"3704"},{"province_id":"23","name":"昌江县","id":"3705"},{"province_id":"23","name":"白沙县","id":"3706"},{"province_id":"23","name":"琼中县","id":"3707"},{"province_id":"23","name":"陵水县","id":"3708"},{"province_id":"23","name":"保亭县","id":"3709"},{"province_id":"23","name":"乐东县","id":"3710"},{"province_id":"23","name":"三沙市","id":"3711"}],
                    "24":[{"province_id":"24","name":"贵阳市","id":"2144"},{"province_id":"24","name":"六盘水市","id":"2150"},{"province_id":"24","name":"遵义市","id":"2155"},{"province_id":"24","name":"铜仁市","id":"2169"},{"province_id":"24","name":"毕节市","id":"2180"},{"province_id":"24","name":"安顺市","id":"2189"},{"province_id":"24","name":"黔西南州","id":"2196"},{"province_id":"24","name":"黔东南州","id":"2205"},{"province_id":"24","name":"黔南州","id":"2222"}],
                    "25":[{"province_id":"25","name":"昆明市","id":"2235"},{"province_id":"25","name":"曲靖市","id":"2247"},{"province_id":"25","name":"玉溪市","id":"2258"},{"province_id":"25","name":"昭通市","id":"2270"},{"province_id":"25","name":"普洱市","id":"2281"},{"province_id":"25","name":"临沧市","id":"2291"},{"province_id":"25","name":"保山市","id":"2298"},{"province_id":"25","name":"丽江市","id":"2304"},{"province_id":"25","name":"文山州","id":"2309"},{"province_id":"25","name":"红河州","id":"2318"},{"province_id":"25","name":"西双版纳州","id":"2332"},{"province_id":"25","name":"楚雄州","id":"2336"},{"province_id":"25","name":"大理州","id":"2347"},{"province_id":"25","name":"德宏州","id":"2360"},{"province_id":"25","name":"怒江州","id":"2366"},{"province_id":"25","name":"迪庆州","id":"4108"}],
                    "26":[{"province_id":"26","name":"拉萨市","id":"2951"},{"province_id":"26","name":"那曲地区","id":"3107"},{"province_id":"26","name":"山南地区","id":"3129"},{"province_id":"26","name":"昌都地区","id":"3138"},{"province_id":"26","name":"日喀则地区","id":"3144"},{"province_id":"26","name":"阿里地区","id":"3970"},{"province_id":"26","name":"林芝市","id":"3971"}],
                    "27":[{"province_id":"27","name":"西安市","id":"2376"},{"province_id":"27","name":"铜川市","id":"2386"},{"province_id":"27","name":"宝鸡市","id":"2390"},{"province_id":"27","name":"咸阳市","id":"2402"},{"province_id":"27","name":"渭南市","id":"2416"},{"province_id":"27","name":"延安市","id":"2428"},{"province_id":"27","name":"汉中市","id":"2442"},{"province_id":"27","name":"榆林市","id":"2454"},{"province_id":"27","name":"商洛市","id":"2468"},{"province_id":"27","name":"安康市","id":"2476"}],
                    "28":[{"province_id":"28","name":"兰州市","id":"2487"},{"province_id":"28","name":"金昌市","id":"2492"},{"province_id":"28","name":"白银市","id":"2495"},{"province_id":"28","name":"天水市","id":"2501"},{"province_id":"28","name":"嘉峪关市","id":"2509"},{"province_id":"28","name":"平凉市","id":"2518"},{"province_id":"28","name":"庆阳市","id":"2525"},{"province_id":"28","name":"陇南市","id":"2534"},{"province_id":"28","name":"武威市","id":"2544"},{"province_id":"28","name":"张掖市","id":"2549"},{"province_id":"28","name":"酒泉市","id":"2556"},{"province_id":"28","name":"甘南州","id":"2564"},{"province_id":"28","name":"临夏州","id":"2573"},{"province_id":"28","name":"定西市","id":"3080"}],
                    "29":[{"province_id":"29","name":"西宁市","id":"2580"},{"province_id":"29","name":"海东地区","id":"2585"},{"province_id":"29","name":"海北州","id":"2592"},{"province_id":"29","name":"黄南州","id":"2597"},{"province_id":"29","name":"海南州","id":"2603"},{"province_id":"29","name":"果洛州","id":"2605"},{"province_id":"29","name":"玉树州","id":"2612"},{"province_id":"29","name":"海西州","id":"2620"}],
                    "30":[{"province_id":"30","name":"银川市","id":"2628"},{"province_id":"30","name":"石嘴山市","id":"2632"},{"province_id":"30","name":"吴忠市","id":"2637"},{"province_id":"30","name":"固原市","id":"2644"},{"province_id":"30","name":"中卫市","id":"3071"}],
                    "31":[{"province_id":"31","name":"乌鲁木齐市","id":"2652"},{"province_id":"31","name":"克拉玛依市","id":"2654"},{"province_id":"31","name":"石河子市","id":"2656"},{"province_id":"31","name":"吐鲁番地区","id":"2658"},{"province_id":"31","name":"哈密地区","id":"2662"},{"province_id":"31","name":"和田地区","id":"2666"},{"province_id":"31","name":"阿克苏地区","id":"2675"},{"province_id":"31","name":"喀什地区","id":"2686"},{"province_id":"31","name":"克孜勒苏柯尔克孜自治州","id":"2699"},{"province_id":"31","name":"巴音郭楞州","id":"2704"},{"province_id":"31","name":"昌吉州","id":"2714"},{"province_id":"31","name":"博尔塔拉州","id":"2723"},{"province_id":"31","name":"伊犁州","id":"2727"},{"province_id":"31","name":"塔城地区","id":"2736"},{"province_id":"31","name":"阿勒泰地区","id":"2744"},{"province_id":"31","name":"五家渠市","id":"4110"},{"province_id":"31","name":"阿拉尔市","id":"15945"},{"province_id":"31","name":"图木舒克市","id":"15946"},{"province_id":"31","name":"铁门关市","id":"53090"},{"province_id":"31","name":"昆玉市","id":"53668"}],
                    "32":[{"province_id":"32","name":"台湾","id":"2768"}],
                    "84":[{"province_id":"84","name":"钓鱼岛","id":"1310"}],
                    "52993":[{"province_id":"52993","name":"香港特别行政区","id":"52994"},{"province_id":"52993","name":"澳门特别行政区","id":"52995"}],


                },
              img1:[]


            }
        },
        methods: {
          beforeRead(file) {
            if (file.type.indexOf('image') < 0) {
              this.$toast('请上传图片文件');
              return false;
            }
            if (file.size > 5 * 1024 * 1024) {
              this.$toast('图片大小不能超过5MB');
              return false;
            }
            return true;
          },

          /**
           * afterRead 钩子函数，在文件读取完成后执行。
           * @param {string} fileId - 当前图片字段在 query 中的 key
           * @param {object} fileObj - Vant Uploader 提供的文件对象，包含 file 和 content 等
           */
          async afterRead(fileId, fileObj) {
            console.log(`开始上传ID为 ${fileId} 的图片`, fileObj.file);

            // 1. 创建 FormData
            const formData = new FormData();
            // 'file' 是后端接口期望的字段名，根据你的后端要求修改
            formData.append('file', fileObj.file);
            // 如果后端需要其他参数，也可以一并添加
            // formData.append('otherParam', 'value');

            try {
              // 2. 发起上传请求
              // 请将 'YOUR_UPLOAD_API_URL' 替换为你真实的后端上传接口地址
              var baseurl=process.env.VUE_APP_BASE_API+"/sys/ossFileMapping/uploadForm";
              console.log(baseurl);
              const response = await axios.post(baseurl, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  // 如果有 token 认证，也需要在这里带上
                  // 'Authorization': 'Bearer ' + your_token
                },
              });

              // 3. 上传成功，处理响应
              // 假设后端返回的数据结构为 { code: 200, data: { url: 'https://example.com/uploaded/image.jpg' } }
              // 请根据你后端实际返回的字段名调整
              console.log(response.data)
              const imageUrl = response.data.data;

              console.log(`图片上传成功，URL: ${imageUrl}`);

              // 4. 更新 query 对象中的对应字段
              // Vant Uploader 需要一个包含 {url: "..."} 结构的对象数组
              this.query[fileId] = [{ url: imageUrl }];

              this.$toast.success('图片上传成功');

            } catch (error) {
              // 5. 上传失败，回滚状态并提示
              console.error(`上传失败:`, error);
              this.$toast.fail('图片上传失败，请重试');

              // 可选：清除本次上传失败的文件记录
              // this.query[fileId] = [];
            }
          },
            formGetLIst(){

                var tempQuery={
                    jobId: this.$route.query.jobId,
                    traderId:this.$route.query.traderId,
             }
                mainAPI.jobOrderFormApplyList(tempQuery).then((result) => {

                    this.formList=result.data;
                    console.log('tttttttttttttttttttttttttttttt');
                    console.log(result);
                });
            },
            formInit(){

                mainAPI.taskInfo(this.query.jobId, null, null).then((result) => {
                   console.log(result.data);
                   this.formTitle=result.data.name
                    this.formIntro=result.data.taskFormIntro
                    var formJson=result.data.taskForm;
                    console.log(JSON.parse(formJson));
                    this.fieldArray=JSON.parse(formJson);

                  // 创建一个新的 query 对象，而不是向已有的对象添加属性
                  const newQuery = {
                    jobId: this.query.jobId, // 保留原有的固定字段
                    traderId: this.query.traderId
                  };

                  // 遍历 fieldArray，为每个字段设置初始值
                  this.fieldArray.forEach(item => {
                    if (item.compType === 'image') {
                      newQuery[item.id] = []; // 图片字段初始化为数组
                    } else {
                      newQuery[item.id] = ''; // 其他字段（如input, province, city）初始化为空字符串
                    }
                  });

                  // 将新的 query 对象赋值给 this.query
                  this.query = newQuery;
                  // -----------------------------

                  // 清空 queryReg 并重新填充
                  this.queryReg = {};
                  for(let i = 0; i < this.fieldArray.length; i++) {
                    let item = this.fieldArray[i];
                    // this.$set(this.query, item.id, ''); // 不再需要，已在上面初始化
                    this.$set(this.queryReg, item.id, item);
                  }

                    for(let i=0;i<this.fieldArray.length;i++){
                       // let item=this.fieldArray[i];
                       // this.$set(this.query,item.id,'');
                       // this.$set(this.queryReg,item.id,item);

                    }
                    console.log(this.query);
                    console.log(this.queryReg);

                });
                var formJson1="[\n" +
                    "    {\n" +
                    "        \"id\":\"name\",\n" +
                    "        \"compType\":\"input\",\n" +
                    "        \"label\":\"姓名\",\n" +
                    "        \"placeholder\":\"请输1入文本\",\n" +
                    "        \"required\":true,\n" +
                    "        \"reg\":\"\",\n" +
                    "        \"ruleError\":\"姓名字段不能为空\"\n" +
                    "    },\n" +
                    "    {\n" +
                    "        \"id\":\"province\",\n" +
                    "        \"compType\":\"province\",\n" +
                    "        \"label\":\"省份\",\n" +
                    "        \"placeholder\":\"请输1入文本省份\",\n" +
                    "        \"required\":true,\n" +
                    "        \"ruleError\":\"省份不能为空\"\n" +
                    "    },\n" +
                    "    {\n" +
                    "        \"id\":\"city\",\n" +
                    "        \"compType\":\"city\",\n" +
                    "        \"label\":\"城市\",\n" +
                    "        \"placeholder\":\"选择城市\",\n" +
                    "        \"required\":true,\n" +
                    "        \"ruleError\":\"城市不能为空\"\n" +
                    "    },\n" +
                    "    {\n" +
                    "        \"id\":\"ext1\",\n" +
                    "        \"compType\":\"input\",\n" +
                    "        \"label\":\"手机号码\",\n" +
                    "        \"placeholder\":\"请输1地址\",\n" +
                    "        \"required\":true,\n" +
                    "        \"reg\":\"/^1(3|4|5|7|8|9)\\\\d{9}$/\",\n" +
                    "        \"ruleError\":\"手机号码格式错误\"\n" +
                    "    }\n" +
                    "]";





            },
            openCityPopup() {
                if (!this.provinceMap[this.query.province]) {
                    this.$toast("请先填写省级地址");
                    return;
                }
                this.cityList = [];
                let result=this.formCityMap[this.provinceMap[this.query.province]]
                    if (result) {
                        result.map(e => {
                            this.cityList.push(e.name);
                        });
                        this.showCity = true;
                    }
            },
            onProvinceConfirm(value, index) {
                this.query.province = value;
                this.query.city = null;
                this.showProvince = false;
            },
            onCityConfirm(value, index) {
                this.query.city = value;
                this.showCity = false;
            },
            submit() {



                for(var key in  this.query) {
                    console.log(key,":", this.query[key]);
                    if(key=="traderId"){
                        continue;
                    }
                    let v=this.query[key];
                    let msg="请先填写相关信息";
                    if(v==undefined||v==null){
                        v="";
                    }
                    if(this.queryReg[key]&&this.queryReg[key].ruleError){
                        msg=this.queryReg[key].ruleError;
                    }
                    console.log(msg);
                    if(v==""){
                        this.$toast(msg);
                        return;
                    }


                    /*
                    if(this.queryReg[key]&&this.queryReg[key].reg){
                        console.log("正则判断"+this.queryReg[key].reg)
                        var reg=this.queryReg[key].reg;
                        var pattern = new RegExp(reg);
                        if(!pattern.test(v)){
                            console.log("1111")
                            this.$toast(msg);
                            return;
                        }
                    }
                    */

                }





              const submitData = { ...this.query };

              // 示例：将图片数组转换为 URL 字符串,如果图片必传，
              for(const item of this.fieldArray) {
                if(item.compType === 'image') {
                  if(submitData[item.id] && submitData[item.id][0].url){
                    submitData[item.id] = submitData[item.id][0].url;
                  }else{
                    if(item.required){
                      this.$toast('请上传图片');
                      return;
                    }
                  }
                }
              }

                mainAPI.jobOrderFormApply(submitData).then((result) => {

                    for(let i=0;i<this.fieldArray.length;i++){
                        let item=this.fieldArray[i];
                      if(item.compType === 'image'){
                        this.$set(this.query,item.id,[]);
                        this.$set(this.queryReg,item.id,item);
                      }else {
                        this.$set(this.query,item.id,'');
                        this.$set(this.queryReg,item.id,item);
                      }


                    }
                    //如果跳转,返回http
                    let temp=result.data;
                    if(temp.indexOf("http")>=0){
                        location.href=temp;
                    }else {
                        this.$toast(result.data);
                        this.formGetLIst();
                    }
                    //this.$toast(result.data);
                    //if(this.query.traderId ==undefined){
                    //    this.formGetLIst();
                    //}
                })
            },
        },
        created() {
            this.formInit();
            //if(this.query.traderId ==undefined) {
                this.formGetLIst();
           // }
                if (this.formProvince) {
                    this.formProvince.map(e => {
                        this.provinceList.push(e.name);
                        this.provinceMap[e.name] = e.id;
                    })
                }
        },
    }

</script>

<style lang="scss" scoped>
    .background {

        text-align: center;
        /*padding: 0;*/
    }

    .inputForm {
        background-color: white;
        width: 80%;
        margin: 0 auto;
        border-radius: 1rem;
        padding: 0.5rem 1rem;
        text-align: center;
    }

    .fromList {

        width: 80%;
        margin: 0 auto;

        padding: 0.5rem 1rem;

    }

</style>
